import React from 'react';
import { Reveal } from './Reveal';
type Tone = 'dark' | 'light';
type Props = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: string;
  tone?: Tone;
  align?: 'left' | 'center';
  className?: string;
};
export function SectionHeader({
  eyebrow,
  title,
  subtitle,
  tone = 'dark',
  align = 'left',
  className = ''
}: Props) {
  const isLight = tone === 'light';
  return <Reveal className={`${align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} ${className}`} data-id="element-301" data-mp="2v6r664xmgy3w">
      {eyebrow && <p className={`eyebrow mb-5 ${isLight ? 'text-gold' : 'text-teal'}`} data-id="element-302" data-mp="3052eucc6l2kj">
          {eyebrow}
        </p>}
      <h2 className={`font-display text-[2rem] font-semibold leading-[1.15] tracking-[-0.02em] sm:text-[2.6rem] lg:text-[3rem] ${isLight ? 'text-white' : 'text-navy'}`} data-id="element-303" data-mp="2l81uitwbk9w3">
        {title}
      </h2>
      {subtitle && <p className={`mt-5 text-[15px] font-light leading-relaxed ${isLight ? 'text-white/70' : 'text-ink/65'}`} data-id="element-304" data-mp="1eshr61f9slpq">
          {subtitle}
        </p>}
    </Reveal>;
}